<template>
  <StandardSearchPageView
    ref="tableWrap"
    rowKey="id"
    :columns="columns"
    :queryParams="queryParams"
    :request-promise="loadList"
    :enableSearch="false"
  >
    <template v-slot:statusText="{ record }">
      {{ getStatusText(record) }}
    </template>
  </StandardSearchPageView>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'SignatureTab',
  components: {
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {},
      statusOptions: [
        { label: '审核中', value: 0 },
        { label: '审核通过', value: 1 },
        { label: '审核未通过', value: 2 },
        { label: '取消审核', value: 3 }
      ],
      columns: [
        { title: 'ID', dataIndex: 'id', width: 120 },
        { title: '签名名称', dataIndex: 'signName', width: 220 },
        {
          title: '状态',
          dataIndex: 'platformStatus',
          scopedSlots: { customRender: 'statusText' },
          width: 140
        },
        { title: '修改时间', dataIndex: 'updatedTime', width: 220 }
      ]
    }
  },
  methods: {
    loadList(requestParams) {
      const { limitDto } = requestParams
      return this.getHttpServices().getNewServeService().post('/smsSignature/pageByMerchant', {
        limitDto
      })
    },
    //转换状态文本
    getStatusText(record) {
      if (record.platformStatusDesc) {
        return record.platformStatusDesc
      }
      const option = this.statusOptions.find(item => item.value === Number(record.platformStatus))
      return option ? option.label : '-'
    }
  }
}
</script>
